import { useState, useRef } from "react";

export const useNetworkGraphChart = (title, configTooltip = {}) => {
    const chartRef = useRef(null); // 🔹 Referencia al gráfico

    const [options, setOptions] = useState({
        chart: {
            type: "networkgraph",
            height: 700,
            animation: false,
            events: {
                load: function () {
                    chartRef.current = this; // 🔹 Guarda la instancia del gráfico
                },
            },
        },
        title: {
            text: title,
            align: "center",
        },
        tooltip: configTooltip,
        plotOptions: {
            networkgraph: {
                keys: ["from", "to"],
                layoutAlgorithm: {
                    enableSimulation: false,
                    integration: "verlet",
                    approximation: "barnes-hut",
                    gravitationalConstant: 0.01,
                },
                draggable: false,
            },
            series: {
                animation: false,
                turboThreshold: 1,
            },
        },
        turboThreshold: 1,
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando datos...", // 🔹 Mensaje del loading
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        series: [
            {
                accessibility: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    linkFormat: "",
                },
                id: "reddit-graph",
            },
        ],
        credits: { enabled: false },
    });

    const showLoading = () => {
        if (chartRef.current) {
            chartRef.current.showLoading();
        }
    };

    const hideLoading = () => {
        if (chartRef.current) {
            chartRef.current.hideLoading();
        }
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
    };
};
